<template>
  <el-dialog
    class="process-mind-map-dialog process-mind-map-source-dialog fishbone-form-detail-dialog pc-pick-detail-dialog"
    v-dialogDrag
    :visible.sync="innerVisible"
    width="96vw"
    append-to-body
    top="4vh"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @open="loadData"
    @closed="resetData">
    <div slot="title" class="fishbone-form-detail-dialog__title">
      <span>{{ $LANG('', '生产投料单') }}</span>
    </div>
    <div class="fishbone-form-detail-dialog__body">
      <el-table
        :data="tableData"
        border
        size="small"
        ref="detailTable"
        class="custom-table-border fishbone-form-detail-dialog__table"
        v-loading="loading"
        :element-loading-text="$LANG('1959', '加载中')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 251, 255, 0.8)"
        show-summary
        :summary-method="getSummary"
        :cell-style="{ padding: '2px' }"
        :header-cell-style="headStyle"
        cell-class-name="clearPadding2"
        height="calc(88vh - 97px)"
        highlight-current-row>
        <el-table-column :label="$LANG('0310', '序号')" type="index" width="60"></el-table-column>
        <el-table-column
          v-for="item in visibleColumns"
          :key="item.key"
          :prop="item.key"
          :label="item.title"
          show-overflow-tooltip
          :align="item.align"
          :sortable="item.edcss !== 'checkbox' && item.key !== 'RN' && item.sortable === 'N'"
          :min-width="item.width">
          <template slot-scope="scope">
            <el-checkbox
              v-if="item.edcss === 'checkbox'"
              disabled
              true-label="Y"
              false-label="N"
              v-model="scope.row[item.key]">
            </el-checkbox>
            <el-link v-else-if="item.key === 'IDNO'" :underline="false">
              <span class="pc-pick-detail-dialog__idno">{{ displayText(scope.row[item.key]) }}</span>
            </el-link>
            <span v-else v-text="displayText(scope.row[item.key])"></span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>

<script>
import { getTabColOrData } from '../../api/user'

export default {
  name: 'PcPickDetailDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    node: {
      type: Object,
      default: function () { return null }
    }
  },
  data: function () {
    return {
      loading: false,
      columns: [],
      tableData: []
    }
  },
  computed: {
    innerVisible: {
      get: function () { return this.visible },
      set: function (value) { this.$emit('update:visible', value) }
    },
    visibleColumns: function () {
      return this.columns.filter(function (item) { return item.thide === 'N' })
    },
    vUsername: function () {
      return this.$cookies.get('v_telno')
    },
 
    tableUrl: function () {
      return  'xuper_auth/getTableRecMany'
    }
  },
  methods: {
    resetData: function () {
      this.loading = false
      this.columns = []
      this.tableData = []
    },
    loadData: function () {
      this.loading = true
      this.loadColumns().then(function (columns) {
        this.columns = columns
        return this.loadRows().catch(function () {
          return []
        })
      }.bind(this)).then(function (rows) {
        this.tableData = rows || []
        this.$nextTick(function () {
          if (this.$refs.detailTable && this.$refs.detailTable.doLayout) this.$refs.detailTable.doLayout()
        })
      }.bind(this)).catch(function (error) {
        this.$emit('error', (error && error.message) || this.$LANG('1442', '提示'))
      }.bind(this)).finally(function () {
        this.loading = false
      }.bind(this))
    },
    loadColumns: function () {
      return getTabColOrData(this.tableUrl,  'v_sys_form_fld', 'idseq', '407576', 'lstseq', '3', '', '', ' order by sortby,lstseq').then(function (res) {
        var list = (res && res.result) || []
        return list.map(function (item) {
          return {
            title: this.$translate.getColTitle(item, this.$store.state.lang),
            key: item.key,
            align: item.align,
            width: item.width,
            thide: item.THIDE,
            fhide: item.FHIDE,
            edcss: item.EDCSS,
            disabled: item.DISABLED,
            dotnum: item.DOTNUM,
            sortable: item.SORTABLE
          }
        }.bind(this))
      }.bind(this))
    },
    loadRows: function () {
      var payload
      try {
        payload = this.getDynamicPayload()
      } catch (error) {
        return Promise.resolve([])
      }
      return getTabColOrData(
        this.tableUrl,
 
        payload.p_table,
        payload.p_key,
        payload.p_value,
        payload.p_key2,
        payload.p_value2,
        payload.p_key3,
        payload.p_value3,
        payload.p_cond
      ).then(function (res) {
        return (res && res.result) || []
      })
    },
    getNodeData: function () {
      return (this.node && this.node.nodeData) || {}
    },
    getRequiredSourceParams: function () {
      var row = this.getNodeData()
      var missing = []
      var params = {
        ORDNO: row.ORDNO,
        MATNO: row.MATNO,
        CORPID: row.CORPID
      }
      Object.keys(params).forEach(function (key) {
        if (params[key] === undefined || params[key] === null || params[key] === '') missing.push(key)
      })
      if (missing.length) throw new Error('MISSING_SOURCE_PARAMS')
      return params
    },
    escapeQueryValue: function (value) {
      return String(value).trim().replace(/'/g, "''")
    },
    getDynamicPayload: function () {
      var params = this.getRequiredSourceParams()
      return {
        p_key: '',
        p_value: '',
        p_key2: 'corpid',
        p_value2: params.CORPID,
        p_key3: '',
        p_value3: '',
        p_table: 'V_PC_PICKDTL_QRY',
        p_cond: " and IDNO like '%%' and ORDNO like '%" + this.escapeQueryValue(params.ORDNO) + "%' and MATNO like '%" + this.escapeQueryValue(params.MATNO) + "%' and isstk ='N' order by IDNO desc"
      }
    },
    displayText: function (value) {
      return value === undefined || value === null || value === '' ? '-' : value
    },
    headStyle: function (params) {
      var column = params.column || {}
      if (column.property === 'ACTQTY' || column.property === 'TAXAMT' || column.property === 'TTLWT') return 'color:red'
    },
    getSummary: function (param) {
      var sums = []
      var sumFields = ['ACTQTY', 'TAXAMT', 'TTLWT']
      param.columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = this.$LANG('0280', '合计')
          return
        }
        if (sumFields.indexOf(column.property) === -1) return
        var values = param.data.map(function (item) { return Number(item[column.property]) })
        var sumValue = values.reduce(function (prev, curr) {
          if (!isNaN(curr)) return Number(prev) + Number(curr)
          return prev
        }, 0)
        sums[index] = sumValue ? sumValue.toFixed(2) : ''
      }.bind(this))
      return sums
    }
  }
}
</script>

<style scoped>
.fishbone-form-detail-dialog__title {
  display: flex;
  align-items: center;
  min-height: 40px;
  padding: 0 56px 0 20px;
  border-bottom: 1px solid #ebeef5;
  background: #fff;
  color: #1f2f3d;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
}
.fishbone-form-detail-dialog__body {
  min-height: 70vh;
}
.fishbone-form-detail-dialog__table {
  width: 100%;
}
.pc-pick-detail-dialog__idno {
  color: #409eff;
  font-size: 13px;
  font-weight: 700;
  border-bottom: 1px solid #409eff;
}
</style>

<style lang="less">
.process-mind-map-dialog.pc-pick-detail-dialog {
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 10px;
  }
  .custom-table-border .el-table__body td,
  .custom-table-border .el-table__header th {
    border-color: rgb(184, 181, 181);
    border-width: 1px;
  }
}
</style>
